import { get } from 'lodash';

const root = state =>
  get(state, 'KitchenPrepWorksheetState.kitchenPrepWorksheetListState');

export const getKitchenPrepWorksheetItems = state =>
  get(root(state), 'kitchenPrepWorksheetItems', []);
export const getFetchKitchenPrepWorksheetLoading = state =>
  get(root(state), 'fetchKitchenPrepWorksheetLoading', false);
export const getFetchWHKITListLoading = state =>
  get(root(state), 'fetchWHKITListLoading', false);
export const getWHKITListData = state => get(root(state), 'wHKITListData', []);
export const getFetchWHKITListLoadingError = state =>
  get(root(state), 'fetchWHKITListLoadingError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);
export const getFetchKitchenPrepWorksheetError = state =>
  get(root(state), 'fetchKitchenPrepWorksheetError', null);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintError = state => get(root(state), 'printError', null);
export const getCloseLoading = state => get(root(state), 'closeLoading', false);
export const getCloseSuccess = state => get(root(state), 'closeSuccess', null);
export const getCloseError = state => get(root(state), 'closeError', null);
export const getPrintData = state => get(root(state), 'printData', null);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/kitchenPrepWorksheet/selectors.js